import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowRight, CalendarDays, ClipboardList } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/pep-vida/_authed/dashboard')({
  component: DashboardPage,
});

export function DashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <ClipboardList className="h-4 w-4" />
            Dashboard
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Acompanhe o sistema e acesse rapidamente as áreas do PEP-Vida.
          </p>
          <Button
            type="button"
            onClick={() => navigate({ to: '/pep-vida/agenda' })}
          >
            <CalendarDays className="mr-2 h-4 w-4" />
            Abrir agenda médica
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
